"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var exchange_clients_commons_1 = require("@mulesoft/exchange-clients-commons");
var debug_1 = __importDefault(require("debug"));
var url_1 = require("url");
var log = (0, debug_1.default)('exchange:authorization:service');
var AuthorizationService = /** @class */ (function (_super) {
    __extends(AuthorizationService, _super);
    function AuthorizationService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Pings the Core Services service
         *
         * @returns True if the service is up, false if it's not
         */
        _this.ping = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, response, isOk, error_1;
            var context = _b.context;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = (0, url_1.format)(__assign(__assign({}, this.config.services.cs.uri), { pathname: '/api/status' }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetch(url, {
                                context: context
                            })];
                    case 2:
                        response = _c.sent();
                        isOk = response.status === 200;
                        return [2 /*return*/, isOk];
                    case 3:
                        error_1 = _c.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Executes authorization context endpoint
         * Read about interface [here](https://anypoint.mulesoft.com/exchange/portals/anypoint-platform/f1e97bc6-315a-4490-82a7-23abe036327a.anypoint-platform/access-management-api/minor/1.0/console/method/%234529/)
         *
         * @returns Authorized resources
         */
        _this.getContext = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, requestCount, getBatch, results;
            var _this = this;
            var context = _b.context, namespace = _b.namespace, actions = _b.actions, resourceTemplates = _b.resourceTemplates, _c = _b.batchSize, batchSize = _c === void 0 ? 500 : _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (batchSize <= 0) {
                            throw new Error('Invalid batchSize provided');
                        }
                        url = (0, url_1.format)(__assign(__assign({}, this.config.services.cs.uri), { pathname: '/api/authorize/context' }));
                        log('getting context', namespace, actions, resourceTemplates, batchSize);
                        requestCount = 0;
                        getBatch = function () {
                            var args_1 = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args_1[_i] = arguments[_i];
                            }
                            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (accum) {
                                var body, response, json, newAccum;
                                if (accum === void 0) { accum = []; }
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            body = JSON.stringify({
                                                namespace: namespace,
                                                actions: actions,
                                                resourceTemplates: resourceTemplates,
                                                offset: accum.length,
                                                limit: batchSize
                                            });
                                            return [4 /*yield*/, this.fetch(url, {
                                                    method: 'POST',
                                                    context: context,
                                                    body: body
                                                })];
                                        case 1:
                                            response = _a.sent();
                                            return [4 /*yield*/, response.json()];
                                        case 2:
                                            json = _a.sent();
                                            // no results from last request, return empty array
                                            if (json.data.length === 0) {
                                                return [2 /*return*/, accum];
                                            }
                                            newAccum = accum.concat(json.data);
                                            // if got less results than requested or results count reach total expected, return
                                            if (json.data.length < batchSize || accum.length >= json.total) {
                                                return [2 /*return*/, newAccum];
                                            }
                                            requestCount += 1;
                                            this.logger.warn({
                                                requestId: context.id,
                                                message: "Authorization context contains ".concat(json.total, " results. Doing context authorize call #").concat(requestCount)
                                            });
                                            return [2 /*return*/, getBatch(newAccum)];
                                    }
                                });
                            });
                        };
                        return [4 /*yield*/, getBatch()];
                    case 1:
                        results = _d.sent();
                        return [2 /*return*/, results];
                }
            });
        }); };
        /**
         * Executes authorize endpoint
         * Read about interface [here](https://anypoint.mulesoft.com/exchange/portals/anypoint-platform/f1e97bc6-315a-4490-82a7-23abe036327a.anypoint-platform/access-management-api/minor/1.0/console/endpoint/%234441/)
         *
         * @returns true/false
         */
        _this.authorize = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, body, response, json;
            var context = _b.context, namespace = _b.namespace, action = _b.action, resource = _b.resource;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = (0, url_1.format)(__assign(__assign({}, this.config.services.cs.uri), { pathname: '/api/authorize' }));
                        log('getting authorized resources', namespace, action, resource);
                        body = JSON.stringify({
                            namespace: namespace,
                            action: action,
                            resources: Array.isArray(resource) ? resource : [resource]
                        });
                        return [4 /*yield*/, this.fetch(url, {
                                method: 'POST',
                                context: context,
                                body: body
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, !!(json === null || json === void 0 ? void 0 : json.length)];
                }
            });
        }); };
        return _this;
    }
    return AuthorizationService;
}(exchange_clients_commons_1.BaseService));
exports.default = AuthorizationService;
